import React, { useContext, useState, useEffect } from "react";
import { Navbar, Container, Nav, Button, NavDropdown } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis, faUser, faHome, faPhone, faHeart, faShoppingBasket, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { SecurityContext } from '../../security/SecurityContext';
import { TenantContext } from '../../tenant/TenantContext';
import { formatPhone } from "util/Phone";
import { PaymentCartContext } from '../../pages/payment-cart/PaymentCartContext';
import { evenRound } from "util/NumberUtils";
import { formatCurrency } from "util/Currency";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";

function AppNavbar(props) {
  const secCtx = useContext(SecurityContext);
  const { businessConfig } = useContext(TenantContext);
  const { paymentCartItems, calculateTotalAmount } = useContext(PaymentCartContext);
  const [totalPaymentAmount, setTotalPaymentAmount] = useState("0.00");
  const navigate = useNavigate();

  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  };

  useEffect(() => {
    let totalPaymentAmount = calculateTotalAmount(businessConfig.salesTaxRate);
    setTotalPaymentAmount(formatCurrency(evenRound(totalPaymentAmount / 100, 2), businessConfig.locale, businessConfig.currency));
  }, [paymentCartItems]);


  return (
    <Navbar bg="light" expand="lg" >
      <Container fluid>
        <div className="d-flex justify-content-center align-items-center ms-2 ms-lg-0">
          <Button
            variant="dark"
            className="d-lg-none btn-fill d-flex justify-content-center align-items-center rounded-circle p-2"
            onClick={mobileSidebarToggle}>
            <FontAwesomeIcon icon={faEllipsis} />
          </Button>
          <Navbar.Brand className="me-2">

          </Navbar.Brand>
        </div>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="me-2">
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Navbar.Text>
            <b><FontAwesomeIcon icon={faHome} className="me-1" /><span className="me-3">{businessConfig.address + ", " + businessConfig.city + ", " + businessConfig.state + ", " + businessConfig.zip}</span></b>
          </Navbar.Text>
          <Navbar.Text>
            <a href={"tel:+1" + businessConfig.phoneNumber}>{<><b><FontAwesomeIcon icon={faPhone} /><span className="me-2">{formatPhone(businessConfig.phoneNumber)}</span></b></>}</a>
          </Navbar.Text>
          {(businessConfig.type === 'NON_PROFIT') && <Navbar.Text>
            <b><FontAwesomeIcon icon={faHeart} className="me-1" /><span className="me-2">Charity Number: {businessConfig.charityNumber}</span></b>
          </Navbar.Text>
          }
          
          <Nav className="ms-auto" navbar>
          <Nav.Link className="d-flex align-items-center" as={Link} to="/checkout-form">
          {(!_.isEmpty(paymentCartItems)) && 
              <><FontAwesomeIcon icon={faShoppingCart} />
              <small><strong>{totalPaymentAmount}</strong></small></>}
           </Nav.Link>

            {secCtx.authState && <NavDropdown  className="d-flex align-items-center" title={<><FontAwesomeIcon icon={faUser} className="pt-2 me-1" />
            {secCtx.profile.firstName + " " + secCtx.profile.lastName} </>} id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to="/profile">Profile</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/resetpassword">Change Password</NavDropdown.Item>
              {secCtx.authState && <NavDropdown.Item as={Link} to="/logout">Sign Out</NavDropdown.Item>}
            </NavDropdown>
            }

            {!secCtx.authState && <Nav.Item>
              <Nav.Link
                className="m-0"
                as={Link} to="/login">Sign In</Nav.Link>
            </Nav.Item>
            }



          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppNavbar;
